import { Box } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';

interface EmptyStateProps {
  title: string;
  description: string;
}

export const EmptyState = ({ title, description }: EmptyStateProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
        gap: 1,
      }}
    >
      <Typography variant="h3-medium" color={colors.grey[900]}>
        {title}
      </Typography>
      <Typography variant="body" color={colors.grey[700]}>
        {description}
      </Typography>
    </Box>
  );
};
